module.exports = __webpack_public_path__ + "media/images/blue-button-left-0efb09941b2ce8267e7d86469a426664.png";